import React from 'react';
import Home from './home/Home';

const HotSpot = () => <Home />

export default HotSpot;


// WEBPACK FOOTER //
// ./src/components/hotspot/HotSpot.js